import { render, staticRenderFns } from "./GoodAdm.vue?vue&type=template&id=adb5b4e6&scoped=true&"
import script from "./GoodAdm.vue?vue&type=script&lang=js&"
export * from "./GoodAdm.vue?vue&type=script&lang=js&"
import style0 from "./GoodAdm.vue?vue&type=style&index=0&id=adb5b4e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb5b4e6",
  null
  
)

export default component.exports